'use client';

import { c as _c } from "react/compiler-runtime";
import type { LoginStep } from '../../PasswordlessLogin/PasswordlessLogin';
type LoginStepStepperProps = {
  step: LoginStep;
};
type DotState = 'filled' | 'active' | 'grey';
const EMAIL_STEP_STATES: DotState[] = ['filled', 'active', 'grey', 'grey'];
const OTP_STEP_STATES: DotState[] = ['filled', 'filled', 'active', 'grey'];
function getDotClassName(state: DotState) {
  if (state === 'active') {
    return 'h-2 w-8 rounded-full bg-foreground transition-all duration-300';
  }
  if (state === 'filled') {
    return 'h-2 w-2 rounded-full bg-foreground transition-all duration-300';
  }
  return 'h-2 w-2 rounded-full bg-foreground/20 transition-all duration-300';
}
export function LoginStepStepper(t0) {
  const $ = _c(4);
  const {
    step
  } = t0;
  const states = step === "otp" ? OTP_STEP_STATES : EMAIL_STEP_STATES;
  let t1;
  if ($[0] !== states) {
    t1 = states.map(_temp);
    $[0] = states;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex items-center justify-center gap-1.5">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(state, index) {
  return <div key={index} className={getDotClassName(state)} />;
}